import React from 'react';

import classNames from 'classnames';

import './styles.css';

const LabelV2 = ({className, children, htmlFor}: any) => (
  <label
    htmlFor={htmlFor}
    className={classNames('LabelV2 colab-bold', className)}>
    {children}
  </label>
);

export default LabelV2;
